import styled from '@emotion/styled'
import { spacing } from 'main/ui'

export const TextContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`
